export default function Button({
  children, variant = "primary", size = "md", icon: Icon, iconRight: IconRight, loading = false,
  block = false, className = "", type = "button", disabled, ...rest
}) {
  const classes = ["btn", `btn-${variant}`, size !== "md" && `btn-${size}`, block && "btn-block", !children && "btn-icon-only", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={classes} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      {loading ? <span className="btn-spinner" aria-hidden="true" /> : Icon ? <Icon size={size === "sm" ? 14 : 16} aria-hidden="true" /> : null}
      {children ? <span>{children}</span> : null}
      {IconRight && !loading ? <IconRight size={size === "sm" ? 14 : 16} aria-hidden="true" /> : null}
    </button>
  );
}
